// MarketerConsultantTabs.jsx — 마케터 1:1 관리 탭 (2026-10-06 UX)
//   [배정 관리](처음) [1:1급여 정산 · 확인 N] [상담자배분]
//   PC = 표준 알약 토글(stdTabGroup/stdTabBtn 톤), 휴대폰 = 밑줄 탭(정산서 관리 휴대폰 탭과 같은 톤, 화면에서 상단바 52px 아래에 붙음)
import React from 'react';

export const TAB_ITEMS = [
  { key: 'assign', label: '배정 관리' },
  { key: 'charge', label: '1:1급여 정산' },
  { key: 'share', label: '상담자배분' },
];

const T = {
  pillGroup: { display: 'inline-flex', flexWrap: 'wrap', gap: 2, padding: 3, borderRadius: 999, background: 'var(--bg-subtle)', alignSelf: 'flex-start' },
  pill: (active) => ({
    minHeight: 38, borderRadius: 999, padding: '0 16px', border: 'none', cursor: 'pointer',
    fontSize: 13, fontWeight: active ? 800 : 600, display: 'inline-flex', alignItems: 'center', gap: 6,
    background: active ? 'var(--std-pill-on-bg, rgba(59,154,242,0.12))' : 'transparent',
    color: active ? 'var(--std-pill-on-text, #1d7de6)' : 'var(--text-muted)',
  }),
  // 휴대폰은 main 이 스크롤하고 위 여백이 72px(AdminLayout pt-[72px]) — sticky 기준이 그 여백 안쪽이라
  //   top -20 이어야 화면에서 상단바(52px) 바로 아래에 붙는다(실측 2026-10-06: top 52 → 124px 에 붙음)
  bar: {
    position: 'sticky', top: -20, zIndex: 20, display: 'flex', background: 'var(--bg-card)',
    borderBottom: '1px solid var(--border)', margin: '0 -16px', padding: '0 4px',
  },
  under: (active) => ({
    flex: 1, minHeight: 46, border: 'none', background: 'none', cursor: 'pointer', fontSize: 14,
    fontWeight: active ? 800 : 600, color: active ? '#2563eb' : 'var(--text-muted)',
    borderBottom: active ? '2.5px solid #2563eb' : '2.5px solid transparent',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5,
  }),
  badge: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 18, height: 18, borderRadius: 9,
    padding: '0 5px', fontSize: 11, fontWeight: 800, background: 'rgba(245,158,11,0.18)', color: '#b45309',
  },
};

// 회사 고르기(본사 화면에서 회사가 둘 이상일 때) — PC·휴대폰 같이 씀. 모양은 종전 S.companyTabs 그대로.
export function CompanyTabs({ vm, styles }) {
  if (!vm.shouldShowCompanyTabs) return null;
  return (
    <div style={styles.companyTabs}>
      {vm.companies.map((company) => (
        <button
          key={company.code}
          type="button"
          style={styles.companyTab(vm.activeTab === company.code)}
          onClick={() => vm.setActiveTab(company.code)}
        >
          {company.name}
        </button>
      ))}
    </div>
  );
}

export function MarketerConsultantTabs({ tab, onChange, pendingCount = 0, variant = 'pill', items = TAB_ITEMS }) {
  const underline = variant === 'underline';
  return (
    <div style={underline ? T.bar : T.pillGroup} role="tablist" aria-label="마케터 1:1 관리 메뉴">
      {items.map((item) => {
        const active = tab === item.key;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={active}
            style={underline ? T.under(active) : T.pill(active)}
            onClick={() => onChange(item.key)}
          >
            {underline && item.key === 'charge' ? '1:1급여' : item.label}
            {item.key === 'charge' && pendingCount > 0 && <span style={T.badge}>확인 {pendingCount}</span>}
          </button>
        );
      })}
    </div>
  );
}
